<template lang="pug">
.page-home-slideshow
  carousel(
    v-if="slides.length",
    :autoplay="true",
    :loop="true",
    :nav="false",
    :margin="10",
    :center="true",
    :responsive="{ 0: { items: 1 }, [smThreshold]: { items: 3 } }",
    :auto-width="!sm"
  )
    img.page-home-carousel-img(
      v-for="(img, i) in slides",
      :key="i",
      :src="img"
    )
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  computed: {
    slides() {
      return this.$rest("slides").list.map(({ img }) => this.files + img);
    },
    smThreshold() {
      return this.$vuetify.breakpoint.thresholds.sm;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  beforeCreate() {
    this.$rest("slides").get();
  },

  components: {
    carousel,
  },
};
</script>
<style>
@media screen and (min-width: 960.001px) {
  .page-home-carousel-img {
    width: calc((100vw - 20px) * 0.5) !important;
  }
}
.page-home-slideshow .owl-dots {
  position: absolute;
  bottom: 2px;
  width: 100%;
}
.page-home-slideshow .owl-dot span {
  background-color: white !important;
}
.owl-dot.active span {
  background-color: var(--v-primary-base) !important;
}
.owl-dot:focus {
  outline: none;
}
.owl-dots.disabled {
  display: block !important;
}
</style>
